module.exports = __webpack_public_path__ + "static/media/internal_env_4_hero.f84e4fc1.webp";